var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Input from "../inputs/Input";
import { Label } from "../inputs/Label";
import { useUnitValue } from "../common";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex: 1;\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tflex: 1;\n\tdisplay: flex;\n\talign-items: center;\n"])));
var Slider = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex: 2;\n\twidth: 100%;\n\n\tappearance: none;\n\twidth: 100%;\n\theight: 2px;\n\tbackground: #555a;\n\toutline: none;\n\n\t&::-webkit-slider-thumb {\n\t\tappearance: none;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\tbackground: #4285F4;\n\t\tcursor: pointer;\n\t}\n"], ["\n\tflex: 2;\n\twidth: 100%;\n\n\tappearance: none;\n\twidth: 100%;\n\theight: 2px;\n\tbackground: #555a;\n\toutline: none;\n\n\t&::-webkit-slider-thumb {\n\t\tappearance: none;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\tbackground: #4285F4;\n\t\tcursor: pointer;\n\t}\n"])));
export default (function (_a) {
    var title = _a.title, value = _a.value, onChange = _a.onChange;
    var _b = useUnitValue(value), amount = _b.amount, unit = _b.unit, setAmount = _b.setAmount;
    var changed = function (e) {
        var val = parseInt(e.target.value);
        setAmount(val);
        onChange(val + unit);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(Label, null, title),
        React.createElement(Input, { value: value, onChange: onChange }),
        React.createElement(Slider, { className: "shadow-picker__slider", type: "range", value: amount, onChange: changed, max: 100 })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=SliderField.js.map